import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export const useQueryMemberGetCurrentMembershipSubscriptionAsMember = (
  { api }: { api: ApiType },
  opts?: {
    enabled?: boolean;
    refetchOnWindowFocus?: boolean;
  },
) => {
  return useQuery({
    queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
    queryFn: async () =>
      (await api.profileApi.getCurrentMembershipSubscription()).data,
    ...opts,
  });
};
